import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';

import {TotalComponent} from "./total.component";


const routes: Routes = [
  {
    path: 'total',
    component: TotalComponent,
  },
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
  ],
})
export class TotalRoutingModule {}
